import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@webfox-sc/core';
import { COLORS } from '../../theme/theme';

const theme = {
  root: {
    fontFamily: '"radikal", sans-serif',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    color: 'white',
    textTransform: 'uppercase',
    padding: '15px 24px',
    background: COLORS.CI_BLUE_3,
    borderRadius: '5px',
    transition: 'background-color 0.1s ease',
    span: {
      marginLeft: '10px',
    },
    svg: {
      width: '14px',
      maxWidth: 'none',
      height: '14px',
    },
    '&[data-with-icon]': {
      paddingLeft: '18px',
    },
    '&[data-with-icon-right]': {
      paddingRight: '18px',
    },
    '&[data-with-icon-only]': {
      padding: 0,
      width: '50px',
      height: '50px',
    },
    '.wfsc-button__label': {
      color: 'white',
    },
    '.ui-button__label': {
      color: 'white',
    },
    '&:hover': {
      background: COLORS.CI_RED,
    },
    '&:active': {
      background: COLORS.CI_RED,
    },
    '&[data-active]': {
      background: COLORS.CI_RED,
    },
  },
};

const ButtonSecondary = (props) => {
  const { minWidth } = props;

  const inlineStyle = {
    minWidth,
  };

  return <Button {...props} theme={theme} style={inlineStyle} />;
};

ButtonSecondary.propTypes = {
  ...Button.propTypes,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  icon: PropTypes.node,
  minWidth: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

ButtonSecondary.defaultProps = {
  ...Button.defaultProps,
  label: undefined,
  ariaLabel: undefined,
  icon: undefined,
  minWidth: undefined,
  active: false,
  disabled: false,
  onClick: () => {},
};

export default ButtonSecondary;
